// Inline SVG glyphs for the three Monte-Carlo distributions. Each
// renders a 14×10 mini-shape: a bell curve for `normal`, a flat
// rectangle for `uniform`, a triangle for `triangular`. Used in the
// MeasureTable's Verteilung column chip + the picker popover so the
// shape is glanceable without reading the label.
//
// Stroke + fill follow currentColor so the chip's active/inactive
// color cascade applies.

const STROKE_WIDTH = 1.4;

export default function DistIcon({ kind, size = 14, className = '' }) {
  if (kind === 'uniform') {
    return (
      <svg
        width={size} height={(size * 10) / 14}
        viewBox="0 0 14 10"
        fill="none" stroke="currentColor" strokeWidth={STROKE_WIDTH}
        strokeLinecap="round" strokeLinejoin="round"
        className={className} aria-hidden="true"
      >
        <line x1="1.5" y1="9" x2="3" y2="9" />
        <line x1="3" y1="9" x2="3" y2="2" />
        <line x1="3" y1="2" x2="11" y2="2" />
        <line x1="11" y1="2" x2="11" y2="9" />
        <line x1="11" y1="9" x2="12.5" y2="9" />
      </svg>
    );
  }
  if (kind === 'triangular') {
    return (
      <svg
        width={size} height={(size * 10) / 14}
        viewBox="0 0 14 10"
        fill="none" stroke="currentColor" strokeWidth={STROKE_WIDTH}
        strokeLinecap="round" strokeLinejoin="round"
        className={className} aria-hidden="true"
      >
        <line x1="1.5" y1="9" x2="7" y2="2" />
        <line x1="7" y1="2" x2="12.5" y2="9" />
      </svg>
    );
  }
  // normal — bell curve via two quadratic bezier halves
  return (
    <svg
      width={size} height={(size * 10) / 14}
      viewBox="0 0 14 10"
      fill="none" stroke="currentColor" strokeWidth={STROKE_WIDTH}
      strokeLinecap="round" strokeLinejoin="round"
      className={className} aria-hidden="true"
    >
      <path d="M 1.5 9 C 3 9, 4 2, 7 2 C 10 2, 11 9, 12.5 9" />
    </svg>
  );
}
